<template>
  <nav>
    <v-container>
      <v-app-bar app class="elevation-0 border" 
      outlined>
        <v-btn icon @click.stop="drawer = !drawer" aria-label="Menu"
        class=""  ><v-icon class="">mdi-menu</v-icon></v-btn
        >
        <v-spacer class="hidden-md-and-up"></v-spacer>
        <router-link :to="'/'" class="logo" v-if="!drawer">
          <div
            class="text-h6 pl-3"
            style="font-size: medium"
            :class="{
              'title-item': !$vuetify.theme.dark,
              'title-item-dark': $vuetify.theme.dark,
            }"
          >
            <span
              class="onlinetollText"
              :class="{
                'secondary--text': !$vuetify.theme.dark,
                'white--text': $vuetify.theme.dark,
              }"
              >Free Online
            </span>
            <span class="freetext primary--text">Tool </span>
          </div>
        </router-link>

        <v-spacer></v-spacer>
        <div class="desknav hidden-md-and-down" v-if="logedIn">
          <v-btn icon small aria-label="Dark-light mode" class="mr-1" @click="logoutAdmin()">
            <v-icon small class="" color="primary" >mdi-logout</v-icon>
          </v-btn>
        </div>
        <div class="desknav hidden-md-and-down" v-if="logedIn">
          <v-btn small  aria-label="Expenses" to="/expenses" class="text" elevation="0" text >
           Expenses
          </v-btn>
        </div>

        <v-btn
          icon
          v-if="!$vuetify.theme.dark"
          @click="toggleTheme()"
          aria-label="Dark-light mode"
          small
          class="mr-1"
        >
          <v-icon small class="" color="primary">mdi-weather-night</v-icon>
        </v-btn>
        <v-btn
          icon
          v-if="$vuetify.theme.dark"
          @click="toggleTheme()"
          aria-label="Dark-light mode"
          small
          class="mr-1"
        >
          <v-icon small color="primary">mdi-white-balance-sunny</v-icon>
        </v-btn>
      </v-app-bar>
      <v-navigation-drawer class="pb-4" app fixed v-model="drawer">
        <router-link :to="'/'" class="logo">
          <div
            class="text-h6 text-center py-3"
            style="font-size: medium"
            :class="{
              'title-item': !$vuetify.theme.dark,
              'title-item-dark': $vuetify.theme.dark,
            }"
          >
            <span
              class="onlinetollText"
              :class="{
                'secondary--text': !$vuetify.theme.dark,
                'white--text': $vuetify.theme.dark,
              }"
              >Free Online
            </span>
            <span class="freetext primary--text">Tool </span>
          </div>
        </router-link>

        <!-- <v-divider></v-divider> -->

        <v-list dense>
          <!-- <v-list-group
            :value="false"
            prepend-icon="mdi-account-edit"
            v-if="logedIn"
          >
            <template v-slot:activator>
              <v-list-item-title>Admin</v-list-item-title>
            </template>

            <v-list-item
              v-for="(x, i) in adminLinks"
              :key="i"
              link
              class="pl-8"
              :to="x.link"
            >
              <v-list-item-icon class="mx-2">
                <v-icon v-text="x.icon" size="20"></v-icon>
              </v-list-item-icon>
              <v-list-item-title
                v-text="x.title"
                class="px-0 mx-0 primary--text"
              ></v-list-item-title>
            </v-list-item>
          </v-list-group> -->
          <v-list-item link text  v-for="(item,idx) in links" :key="idx" :to="item.link" class="primary--text">
            <v-list-item-icon >
              <v-icon dense>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content >
              <v-list-item-title class="font-weight-regular"> {{  item.title}}  </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link   to="/expenses" v-if="logedIn" class="primary--text">
            <v-list-item-icon>
              <v-icon>mdi-currency-rupee</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="font-weight-regular">Expenses </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item   v-if="logedIn" @click="logoutAdmin()" class="primary--text">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="font-weight-regular">Log Out </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-group :value="false" prepend-icon="mdi-lock-outline">
            <template v-slot:activator>
              <v-list-item-title>Password</v-list-item-title>
            </template>

            <v-list-item
              v-for="(x, i) in password"
              :key="i"
              link
              class="pl-8"
              :to="x.link"
            >
              <v-list-item-icon class="mx-2">
                <v-icon v-text="x.icon" size="20"></v-icon>
              </v-list-item-icon>
              <v-list-item-title
                v-text="x.title"
                class="px-0 mx-0"
              ></v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group :value="false" prepend-icon="mdi-palette">
            <template v-slot:activator>
              <v-list-item-title>Color</v-list-item-title>
            </template>

            <v-list-item
              v-for="(x, i) in colorLinks"
              :key="i"
              link
              class="pl-8"
              :to="x.link"
            >
              <v-list-item-icon class="mx-2">
                <v-icon v-text="x.icon" size="20" color="primary"></v-icon>
              </v-list-item-icon>
              <v-list-item-title
                v-text="x.title"
                class="px-0 mx-0"
              ></v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group
            :value="false"
            prepend-icon="mdi-format-text-variant-outline"
          >
            <template v-slot:activator>
              <v-list-item-title>Text</v-list-item-title>
            </template>

            <v-list-item
              v-for="(x, i) in text"
              :key="i"
              link
              class="pl-8"
              :to="x.link"
            >
              <v-list-item-icon class="mx-2">
                <v-icon v-text="x.icon" size="20"></v-icon>
              </v-list-item-icon>
              <v-list-item-title
                v-text="x.title"
                class="px-0 mx-0"
              ></v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-group
            :value="false"
            prepend-icon="mdi-image-multiple-outline"
          >
            <template v-slot:activator>
              <v-list-item-title>Image</v-list-item-title>
            </template>

            <v-list-item
              v-for="(x, i) in imgLinks"
              :key="i"
              link
              class="pl-8"
              :to="x.link"
            >
              <v-list-item-icon class="mx-2">
                <v-icon v-text="x.icon" size="20"></v-icon>
              </v-list-item-icon>
              <v-list-item-title
                v-text="x.title"
                class="px-0 mx-0"
              ></v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group :value="false" prepend-icon="mdi-ip-outline">
            <template v-slot:activator>
              <v-list-item-title>IP</v-list-item-title>
            </template>

            <v-list-item
              v-for="(x, i) in ipinks"
              :key="i"
              link
              class="pl-8"
              :to="x.link"
            >
              <v-list-item-icon class="mx-2">
                <v-icon v-text="x.icon" size="20"></v-icon>
              </v-list-item-icon>
              <v-list-item-title
                v-text="x.title"
                class="px-0 mx-0"
              ></v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group :value="false" prepend-icon="mdi-web">
            <template v-slot:activator>
              <v-list-item-title>Domain</v-list-item-title>
            </template>

            <v-list-item
              v-for="(x, i) in domainLinks"
              :key="i"
              link
              class="pl-8"
              :to="x.link"
            >
              <v-list-item-icon class="mx-2">
                <v-icon v-text="x.icon" size="20"></v-icon>
              </v-list-item-icon>
              <v-list-item-title
                v-text="x.title"
                class="px-0 mx-0"
              ></v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-group :value="false" prepend-icon="mdi-link-variant">
            <template v-slot:activator>
              <v-list-item-title>URL</v-list-item-title>
            </template>

            <v-list-item
              v-for="(x, i) in url"
              :key="i"
              link
              class="pl-8"
              :to="x.link"
            >
              <v-list-item-icon class="mx-2">
                <v-icon v-text="x.icon" size="20" color="primary"></v-icon>
              </v-list-item-icon>
              <v-list-item-title
                v-text="x.title"
                class="px-0 mx-0"
              ></v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group :value="false" prepend-icon="mdi-application-outline">
            <template v-slot:activator>
              <v-list-item-title>Website </v-list-item-title>
            </template>

            <v-list-item
              v-for="(x, i) in website"
              :key="i"
              link
              class="pl-2"
              :to="x.link"
            >
              <v-list-item-icon class="mx-2">
                <v-icon v-text="x.icon" size="20" color="primary"></v-icon>
              </v-list-item-icon>
              <v-list-item-title
                v-text="x.title"
                class="px-0 mx-0"
              ></v-list-item-title>
            </v-list-item>
          </v-list-group> -->
          <!-- <v-list-item link to="/invoice-generator">
            <v-list-item-icon>
              <v-icon size="26">mdi-receipt-outline</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title> Invoice Generator</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <!-- <v-list-item
            v-for="(x, i) in others"
            :key="i"
            link
            class=""
            :to="x.link"
          >
            <v-list-item-icon class="">
              <v-icon v-text="x.icon" size="26"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="x.title" class=""></v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-navigation-drawer>
    </v-container>
  </nav>
</template>

<script>
export default {
  name: "nav-bar",
  components: {},
  data: () => ({
    drawer: true,
    logedIn: false,
    adminLinks: [
      {
        title: "Dashboard",
        link: "/admin/dashboard",
        icon: "mdi-view-dashboard",
      },
      {
        title: "Page Contents",
        link: "/admin/all-page-contents",
        icon: "mdi-file-document-check-outline",
      },
      {
        title: "Links",
        link: "/admin/links",
        icon: "mdi-link",
      },
    ],

    url: [
      {
        title: "URL Shortener",
        link: "/url-shortener",
        icon: "mdi-link-variant-minus",
      },
      {
        title: "URL Encode & Decode",
        link: "/url-encode-and-decode",
        icon: "mdi-link-variant-remove",
      },
    ],

    colorLinks: [
      {
        title: "Color Picker",
        link: "/color-picker",
        icon: "mdi-invert-colors",
      },
      {
        title: "Rgb To Hex",
        link: "/rgb-to-hex",
        icon: "mdi-eyedropper-variant ",
      },
      {
        title: "Hex To RGB",
        link: "/hex-to-rgb",
        icon: "mdi-format-color-highlight",
      },
      // {     // {
      //   title: "Online Barcode Generator",
      //   link: "/online-barcode-generator",
      //   icon: "mdi-barcode-scan",
      // },
      //   title: "Hex To HSL",
      //   link: "/hex-to-hsl",
      //   icon: "mdi-image-filter-center-focus",
      // },
    ],

    imgLinks: [
      {
        title: "Image Compressor",
        link: "/image-compressor",
        icon: "mdi-image-size-select-large",
      },
      {
        title: "Image Resizer",
        link: "/image-resizer",
        icon: "mdi-image-edit-outline",
      },
      {
        title: "Crop Image",
        link: "/crop-image",
        icon: "mdi-crop ",
      },

      {
        title: "PNG Converter",
        link: "/png-converter",
        icon: "mdi-file-png-box",
      },
      {
        title: "JPG Converter",
        link: "/jpg-converter",
        icon: "mdi-file-jpg-box",
      },
      // {
      //   title: "Favicon Converter",
      //   link: "/favicon-converter",
      //   icon: "mdi-image-filter-center-focus",
      // },
    ],
    ipinks: [
      {
        title: "My IP",
        link: "/my-ip",
        icon: "mdi-web",
      },
      {
        title: "IP Address Lookup",
        link: "/ip-address-lookup",
        icon: "mdi-ip",
      },
    ],
    domainLinks: [
      {
        title: "Whois Domain Lookup",
        link: "/whois-domain-lookup",
        icon: "mdi-search-web",
      },
      {
        title: "Domain to IP",
        link: "/domain-to-ip",
        icon: "mdi-ip-outline",
      },
    ],
    password: [
      {
        title: "Random Key Generator",
        link: "/random-key-generator",
        icon: "mdi-text",
      },
      {
        title: "Password Generator",
        link: "/password-generator",
        icon: "mdi-lock-check-outline",
      },

      {
        title: "Password Strength Meter",
        link: "/password-strength-meter",
        icon: "mdi-lock-question",
      },
    ],
    pdf: [
      {
        title: "PDF Viewer",
        link: "/pdf-viewer",
        icon: "mdi-image-filter-center-focus",
      },
    ],
    website: [
      {
        title: "Privacy Policy Generator",
        link: "/privacy-policy-generator",
        icon: "mdi-shield-account-outline",
      },
      {
        title: "Terms & Conditions Generator",
        link: "/trems-and-conditions-generator",
        icon: "mdi-shield-check",
      },
    ],
    text: [
      // {
      //   title: "Text Editor",
      //   link: "/text-editor",
      //   icon: "mdi-format-text-rotation-angle-up",
      // },
      {
        title: "Text Transform",
        link: "/text-transform",
        icon: "mdi-format-text-rotation-angle-up",
      },
      {
        title: "Word Counter",
        link: "/word-counter",
        icon: "mdi-file-word-outline",
      },
      {
        title: "Text to Speech",
        link: "/text-to-speech",
        icon: "mdi-microphone-message",
      },
      // {
      //   title: "Speech to Text",
      //   link: "/speech-to-text",
      //   icon: "mdi-image-filter-center-focus",
      // },
    ],
    others: [
      {
        title: "Digital Clock",
        link: "/digital-clock",
        icon: "mdi-clock-outline",
      },
      {
        title: "Online QR code Generator",
        link: "/online-qr-code-generator",
        icon: "mdi-qrcode",
      },
      // {
      //   title: "Online Barcode Generator",
      //   link: "/online-barcode-generator",
      //   icon: "mdi-barcode-scan",
      // },
    ],
 
    links:[
    {
        title: "Home",
        link: "/",
        icon: "mdi-home",
      },
    {
        title: "Random Key Generator",
        link: "/random-key-generator",
        icon: "mdi-text",
      },
      {
        title: "Password Generator",
        link: "/password-generator",
        icon: "mdi-lock-check-outline",
      },
      {
        title: "Color Picker",
        link: "/color-picker",
        icon: "mdi-invert-colors",
      },
      {
        title: "Rgb To Hex",
        link: "/rgb-to-hex",
        icon: "mdi-eyedropper-variant ",
      },
      {
        title: "Hex To RGB",
        link: "/hex-to-rgb",
        icon: "mdi-format-color-highlight",
      },
      {
        title: "Text Transform",
        link: "/text-transform",
        icon: "mdi-format-text-rotation-angle-up",
      },
      {
        title: "Word Counter",
        link: "/word-counter",
        icon: "mdi-file-word-outline",
      },
      {
        title: "Image Compressor",
        link: "/image-compressor",
        icon: "mdi-image-size-select-large",
      },
      {
        title: "Image Resizer",
        link: "/image-resizer",
        icon: "mdi-image-edit-outline",
      },
      {
        title: "PNG Converter",
        link: "/png-converter",
        icon: "mdi-file-png-box",
      },
      {
        title: "Digital Clock",
        link: "/digital-clock",
        icon: "mdi-clock-outline",
      },
      {
        title: "Online QR code Generator",
        link: "/online-qr-code-generator",
        icon: "mdi-qrcode",
      },
    ]


  }),
  methods: {
    toggleTheme() {
      if (this.$vuetify.theme.dark == true) {
        this.$vuetify.theme.dark = false;
        // set local storage
        localStorage.setItem("dark-theme", false);
      } else {
        this.$vuetify.theme.dark = true;
        // set local storage
        localStorage.setItem("dark-theme", true);
      }
    },

    getTheme() {
      const darkTheme = localStorage.getItem("dark-theme");
      const user = localStorage.getItem("user");
      if (user) {
        this.logedIn = true;
      }

      if (darkTheme === "true") {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    },
    logoutAdmin() {
      localStorage.removeItem("user");
      location.href = "/";
    },
  },

  mounted() {
    this.getTheme();
  },
};
</script>
<style lang="scss" scoped>
@import "../scss/main.scss";
.logo {
  text-decoration: none;
}
.freetext,
.onlinetollText {
  font-size: 1.4rem;
  font-weight: bold;
}
.freetext {
  font-weight: 900;
}
.onlinetollText {
  font-weight: 400;
}
</style>
